module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/desenrola2x-595eda7e1c228d4d9d4b87ad9b6d547e.png";